import React from "react";
import { t } from "i18next";
import FreeContentPage from "@src/components/Tabs/Content/components/FreeContent/FreeContentPage";
import usePageHeading from "@src/customHooks/usePageHeading.js";

const CourseFreeContent = () => {
  usePageHeading(
   { heading: t("pages.courseId.freeContent.index.allFreeContent", "All Free Content"),
   deps: [t],
});

  return <FreeContentPage />;
};

// DEFINING LAYOUT PROPERTIES FOR THIS PAGE
CourseFreeContent.getLayoutProps = () => ({
  accent: true,
  blockHeader: true,
});

export default CourseFreeContent;